import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Grid,
  Button,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { handleAxiosError } from "../../../config/action-config";
import { showAlert } from "../../../actions/alert";
import { Controller, useForm } from "react-hook-form";
import { updateLeave } from "../../../api/leaves";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { deleteHoliday, updateHoliday } from "../../../api/holidays";
import DeleteDialog from "../../../component/DeleteDialogDetailPage";

export default function ViewHolidayDetail({ preloadedValues, refresh }) {
  const user = useSelector((state) => state.user);
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [dayName, setDayName] = useState("");
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: preloadedValues });

  async function onHolidayUpdate(newdata) {
    newdata.holiday_day = dayName;
    try {
      const { data } = await updateHoliday(params.id, newdata, user.token);

      refresh();
      // loadMasterData();
      dispatch(showAlert(data.msg));
      navigate(-2);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  const onDelete = () => {
    deleteHoliday(params.id, user.token)
      .then((res) => {
        if (res.data.status == true) {
          navigate("/holidays");
          dispatch(showAlert(res.data.msg));
        } else {
          dispatch(showAlert(res.data.msg));
        }
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Paper sx={{ p: "1rem" }}>
        <Box
          component="form"
          onSubmit={handleSubmit(onHolidayUpdate)}
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            // borderBottom: 1,
            justifyContent: "space-between",
          }}
        >
          <Grid container spacing={2} sx={{ pt: "1rem" }}>
            <Grid item xs={12} md={6} sm={6}>
              <TextField
                name="occasion"
                label="Occasion"
                required
                fullWidth
                inputRef={register({
                  required: "Occasion is required.",
                })}
                error={Boolean(errors.occasion)}
                helperText={errors.occasion?.message}
              />
            </Grid>

            <Grid item xs={12} md={6} sm={6}>
              <FormControl fullWidth error={Boolean(errors.date_of_holiday)}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Controller
                    render={(props) => (
                      <DesktopDatePicker
                        value={props.value || ""}
                        onChange={(nv) => {
                          props.onChange(nv);
                          setDayName(getDayName(nv));
                        }}
                        label="Date Of Holiday"
                        renderInput={(params) => (
                          <TextField
                            error={Boolean(errors.date_of_holiday)}
                            {...params}
                          />
                        )}
                      />
                    )}
                    rules={{
                      required: "Date of holiday is required.",
                    }}
                    name="date_of_holiday"
                    control={control}
                  />
                </LocalizationProvider>
                <FormHelperText>
                  {errors.date_of_holiday?.message}
                </FormHelperText>
              </FormControl>
            </Grid>

            {/* <Grid item xs={12} md={6} sm={6}>
              <FormControl
                fullWidth
                required
                error={Boolean(errors.holiday_day)}
              >
                <InputLabel>Holiday Day</InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      value={props.value}
                      onChange={props.onChange}
                      MenuProps={{ className: "select-box-height" }}
                    >
                      <MenuItem value="" disabled>
                        --select--
                      </MenuItem>
                      <MenuItem value="Monday">Monday</MenuItem>
                      <MenuItem value="Tuesday">Tuesday</MenuItem>
                      <MenuItem value="Wednesday">Wednesday</MenuItem>
                      <MenuItem value="Thursday">Thursday</MenuItem>
                      <MenuItem value="Friday">Friday</MenuItem>
                    </Select>
                  )}
                  name="holiday_day"
                  label="Holiday Day"
                  control={control}
                  rules={{
                    required: "Holiday Day is required.",
                  }}
                />
                <FormHelperText>{errors.holiday_day?.message}</FormHelperText>
              </FormControl>
            </Grid> */}
            <Grid item xs={12} md={6} sm={6}>
              <FormControl
                fullWidth
                required
                error={Boolean(errors.holiday_type)}
              >
                <InputLabel>Holiday Type</InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      value={props.value}
                      onChange={props.onChange}
                      MenuProps={{ className: "select-box-height" }}
                    >
                      <MenuItem value="" disabled>
                        --select--
                      </MenuItem>
                      <MenuItem value="Regular">Regular</MenuItem>
                      <MenuItem value="Floating">Floating</MenuItem>
                    </Select>
                  )}
                  name="holiday_type"
                  label="Holiday Type"
                  control={control}
                  rules={{
                    required: "Holiday Type is required.",
                  }}
                />
                <FormHelperText>{errors.holiday_type?.message}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  columnGap: 1,
                  ml: "auto",
                }}
              >
                <Button
                  variant="contained"
                  onClick={() => {
                    navigate(-2);
                  }}
                  className="blue-button"
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    setOpen(true);
                  }}
                  style={{ padding: "5px 7px" }}
                >
                  Delete
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  style={{ padding: "5px 7px" }}
                  className="blue-button"
                >
                  Update
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      <DeleteDialog open={open} setOpen={setOpen} onDelete={onDelete} />
    </Box>
  );
}
function disablePrevDates(startDate) {
  const startSeconds = Date.parse(startDate);
  return (date) => {
    return Date.parse(date) < startSeconds;
  };
}
function getDayName(date) {
  return new Intl.DateTimeFormat("en-US", {
    weekday: "long",
  }).format(date);
}
